import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-brand-dark flex flex-col items-center justify-center text-brand-cream gap-4 px-6 text-center" data-testid="payment-cancel">
      <XCircle className="w-14 h-14 text-red-400" />
      <h1 className="font-head text-2xl font-bold">Payment cancelled</h1>
      <p className="text-brand-cream/60">No payment was taken. Your basket is still saved.</p>
      <Button onClick={() => navigate("/checkout")} className="bg-brand-teal hover:bg-brand-teal-dark rounded-2xl h-12 px-6 font-bold">
        Back to checkout
      </Button>
    </div>
  );
}
